export default __webpack_public_path__ + "static/media/playPhilosophy3.89697a92.png";